export enum HTTP_METHOD {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	DELETE = 'DELETE',
	PATH = 'PATH'
}

export enum HTTP_STATUS_CODE {
	SUCCESS = '200',
	BAD_REQUEST = '400',
	NOT_FOUND = '404',
	AUTHORIZATION = '401',
	FORBIDDEN = '403',
	UNKNOWN = '520'
}

export enum HTTP_STATUS_RESPONSE_KEY {
	SUCCESS = 'success',
	BAD_REQUEST = '400',
	NOT_FOUND = '404',
	AUTHORIZATION = '401',
	FORBIDDEN = '403',
	UNKNOWN = '520',
	USER_DONT_HAVE_PERMISSION = 'userDontHavePermission',
	INVITATION_LINK_EXPIRED = 'invitationLinkExpired',
	GUARANTOR_COULD_NOT_BECOME_THEIR_OWN_GUARANTOR = 'guaranteeCouldNotBecomeTheirOwnGuarantor',
	CORPORATE_CAN_NOT_BECOME_THE_GUARANTOR = 'corporateCantBecomeTheGuarantor',
	USER_IS_INACTIVE = 'userIsInactive'
}

export enum ENDPOINT {
	BASE_URL = '/api',
	LOGIN = '/auth/client/login',
	LOGOUT = '/auth/client/logout',
	OTP_VERIFICATION = '/client/account/verify-otp',
	RESEND_OTP = '/client/account/resend-otp',
	INDIVIDUAL_REGISTRATION = '/client/account/register/individual',
	CORPORATE_REGISTRATION = '/client/account/register/corporate',
	FORGOT_PASSWORD = '/client/account/forgot-password',
	CHANGE_FORGOTTERN_PASSWORD = '/client/account/change-forgotten-password',
	CHANGE_PASSWORD = '/client/account/change-password',
	UPDATE_BASIC_INFORMATION = '/client/account/update',
	ACCOUNT_INFO = '/client/account/info',
	UPLOAD_PLATFORM_USAGE = '/client/individual/files/platform-usage-upload',
	CHECK_EMAIL_EXIST = 'auth/client/check-email',
	SIGN_PLATFORM_USAGE = '/client/individual/files/platform-usage-upload',

	FUNDER_ACCOUNT_DETAIL = '/client/individual/funder/account-detail',
	FUNDER_EMPLOYMENT_DETAIL = '/client/individual/funder/employment-detail',
	FUNDER_LOAN_LENDING = '/client/individual/funder/loan-lending',
	FUNDER_BANK_ACCOUNT = '/client/individual/funder/bank-account',
	FUNDER_ONBOARDING_FILE_UPLOAD = '/client/individual/files/upload',
	USER_ONBOARDING_FLATFORM_SUBMIT = '/client/individual/files/onboarding/platform',
	FUNDER_ONBOARDING_DAVE_DRAFT = '/client/individual/funder/draft',
	FUNDER_ONBOARDING_SUBMIT = '/client/individual/funder/submit',
	DOWNLOAD_INDIVIDUAL_FUNDER_REQUEST_FILE = '/client/individual/funder/funder-request-file',
	DOWNLOAD_CORPORATE_FUNDER_REQUEST_FILE = '/client/corporate/funder/funder-request-file',
	DOWNLOAD_INDIVIDUAL_BORROWER_REQUEST_FILE = '/client/individual/borrower/borrower-request-file',
	DOWNLOAD_CORPORATE_BORROWER_REQUEST_FILE = '/client/corporate/borrower/borrower-request-file',
	INDIVIDUAL_FUNDER_ONBOARDING_PROGRESS = '/client/individual/funder/onboarding-progress',
	// FSA Individual
	INDIVIDUAL_FUNDER_FSA = '/client/individual/funder/fsa',
	INDIVIDUAL_FUNDER_SIGN_FSA = '/client/individual/funder/sign-fsa',
	INDIVIDUAL_UPLOAD_FSA_FILE = '/client/individual/funder/upload-fsa-file',
	// FSA Corporate
	CORPORATE_FUNDER_FSA = '/client/corporate/funder/fsa',
	CORPORATE_SIGN_FSA = '/client/corporate/funder/sign-fsa',
	CORPORATE_UPLOAD_FSA_FILE = '/client/corporate/funder/upload-fsa-file',

	FUNDER_FILE_DOWNLOAD = '/client/individual/files/',
	DELETE_FUNDER_FILE = '/client/individual/files/:documentId',

	BORROWER_ACCOUNT_DETAIL = '/client/individual/borrower/account-detail',
	BORROWER_EMPLOYMENT_DETAIL = '/client/individual/borrower/employment-detail',
	INDIVIDUAL_BORROWER_ONBOARDING_PROGRESS = '/client/individual/borrower/onboarding-progress',
	BORROWER_FINANCIAL_DETAIL = '/client/individual/borrower/financial-detail',
	BORROWER_OTHER_DETAIL = '/client/individual/borrower/other-details',
	BORROWER_ONBOARDING_DAVE_DRAFT = '/client/individual/borrower/draft',
	BORROWER_ONBOARDING_SUBMIT = '/client/individual/borrower/submit',

	CORPORATE_FUNDER_COMPANY_DETAIL = '/client/corporate/funder/company-detail',
	CORPORATE_FUNDER_CONTRACT_PERSON = '/client/corporate/funder/contact-person',
	CORPORATE_FUNDER_LOAN_CRITERIA = '/client/corporate/funder/loan-criteria',
	CORPORATE_FUNDER_BANK_ACCOUNT = '/client/corporate/funder/bank-account',
	CORPORATE_FUNDER_ONBOARDING_PROGRESS = '/client/corporate/funder/onboarding-progress',
	CORPORATE_FUNDER_SAVE_DRAFT = '/client/corporate/funder/draft',
	CORPORATE_FUNDER_SUBMIT = '/client/corporate/funder/submit',
	CORPORATE_FUNDER_FILE_UPLOAD = '/client/corporate/files/upload',
	CORPORATE_FUNDER_FILE_DOWNLOAD = '/client/corporate/files/',
	CORPORATE_FUNDER_FUNDER_FILE = '/client/corporate/files/:documentId',

	CORPORATE_BORROWER_ONBOARDING_PROGRESS = '/client/corporate/borrower/onboarding-progress',
	CORPORATE_BORROWER_SAVE_COMPANY_DETAIL = '/client/corporate/borrower/company-detail',
	CORPORATE_BORROWER_SAVE_CONTACT_PERSON = '/client/corporate/borrower/contact-person',
	CORPORATE_BORROWER_SAVE_OTHER_DETAILS = '/client/corporate/borrower/other-details',
	CORPORATE_BORROWER_SAVE_SAFE_DRAFT = '/client/corporate/borrower/draft',
	CORPORATE_BORROWER_SAVE_SUBMIT = '/client/corporate/borrower/submit',

	CHANGE_REQUEST = '/client/change-request',
	LIST_CHANGE_REQUEST = '/client/change-request/list',
	CHANGE_REQUEST_FILE_UPLOAD = '/client/change-request/file/upload',
	CHANGE_REQUEST_FILE_DELETE = '/client/change-request/file/:documentId',
	CHANGE_REQUEST_EXISTING = '/client/change-request/existing-value/:accountId/:type',
	CHANGE_REQUEST_FILE_DOWNLOAD = '/client/change-request/file/download/',
	CHANGE_REQUEST_DELETE_CHANGE_REQUEST = '/client/change-request/remove/:crId',

	CHECK_SELFIE_IMAGE = '/util/pre-validate-selfie',

	SAVE_MORTGAGE_DEAL_DETAILS = '/client/mortgage/save-deal',
	GET_MORTGAGE_DEAL_DETAILS = '/client/mortgage/detail/:id',
	GET_MORTGAGE_DEAL_PROPERTY_DETAILS = '/client/mortgage/property-detail/:id',
	SUBMIT_INVEST_DEAL = '/client/investment/invest-planed-deal',
	SUBMIT_COUNTER_PROPOSAL = '/client/investment/submit-counter-proposal',

	UPLOAD_FILE_INVITE_GUARANTOR = '/client/mortgage/upload/guarantor',

	SAVE_GUARANTOR = '/client/mortgage/save-guarantor',
	DELETE_GUARANTOR_INVITATION = '/client/mortgage/delete-guarantor-invitation/:id',

	UPLOAD_MORTGAGE_APPLICATION_DOC = '/client/mortgage/upload/application',

	DELETE_MORTGAGE_DOC_FILE = '/client/mortgage/document/:documentId',

	DOWNLOAD_MORTGAGE_DOC_FILE = '/client/mortgage/document/',

	SAVE_DRAFT_MORTGAGE_DEAL_FORM = '/client/mortgage/save-draft/:mortgageId',

	GET_MORTGAGE_APPLICATION_LIST = '/client/mortgage/application-list',
	GET_INVITE_MORTGAGE_DEALS = '/client/mortgage/invite-mortgage-deals',
	GET_SUGGESTED_MORTGAGE_DEALS = '/client/mortgage/interested-mortgage-deals',
	ADD_MORTGAGE_DEAL_FAVORITE = '/client/mortgage/add-to-favorites-list',
	GET_MORTGAGE_IMAGE = '/client/mortgage/images/:id',

	SUBMIT_MORTGAGE_DEAL_FORM = '/client/mortgage/submit/:mortgageId',

	GUARANTOR_CHECK_INVITATION = '/client/guarantor/can-consent-for-deal',
	GUARANTOR_CONFIRM_INVITATION = '/client/guarantor/confirm-request',
	GUARANTOR_GET_DEAL_DETAIL = '/client/guarantor/deal/:mortgageId',
	GUARANTOR_CONSENT_INVITATION = '/client/guarantor/consent-a-deal',
	GUARANTOR_REJECT_INVITATION = '/client/guarantor/reject-a-deal',

	GET_GUARANTEE_LIST = '/client/guarantor/list-guarantee',

	RESEND_EMAIL_GUARANTOR = '/client/mortgage/resend-guarantor-invitation',

	RESUBMIT_REQUEST = '/client/onboarding/resubmit-request/:onboardingRequestId',

	DOWNLOAD_DOCUMENT_BORROWER_INDIVIDUAL = '/client/individual/borrower/borrower-request-file',

	DOWNLOAD_DOCUMENT_BORROWER_CORPORATE = '/client/corporate/borrower/borrower-request-file',

	DOWNLOAD_DOCUMENT_FUNDER_INDIVIDUAL = '/client/individual/funder/funder-request-file',
	DOWNLOAD_DOCUMENT_FUNDER_CORPORATE = '/client/corporate/funder/funder-request-file',

	GET_OFFER_LETTER_INFO = '/client/mortgage/offer-letter/:mortgageId',

	SIGN_OFFER_LETTER = '/client/mortgage/offer-letter/sign',
	INIT_PAYMENT = '/client/payment/init',
	SUBMIT_PAYMENT_RESULT = '/client/payment/payment-result',
	SUBMIT_BANK_TRANSFER = '/client/payment/add-bank-transfer',

	FUNDER_ACTION_ON_DEAL = '/client/investment/action-on-proposal',

	FUNDER_LIST_INVESTMENT = '/client/investment/funder-investment',

	BORROWER_LIST_PROPOSAL = '/client/investment/borrower-list-proposal/:mortgageId',

	BORROWER_REJECT_ALL_PROPOSAL = '/client/investment/borrower-reject-all-proposal/:mortgageId',

	BORROWER_APPROVE_ONE_PROPOSAL = '/client/investment/borrower-approve-one-proposal/:mortgageId',

	GET_BIDDING_ID = '/client/investment/bidding-detail/:biddingId',
}
